import React, { useContext, useState } from "react";
import { useRouter } from "next/router";

import ICONS from "../../constants/icons";
import { ModalContext } from "../../../context/ModalContext";

import styles from "./contactCompleteModal.module.css";
import { useAppContext } from "../../../context/AppContext";

const ContactCompleteModal = (): JSX.Element => {
  const { settings } = useAppContext();

  return (
    <div className={styles.container}>
      <div className={styles.modalLeft}>
        <div className={styles.description}>
          <div className={styles.modalBody}>
            <p>
              Thank you for reaching out to us, your feedback is super important
              to make our service the best it can be. We aim to get back to you
              in 24h, if your request is more urgent please send us a whatsapp
            </p>
          </div>
        </div>

        <ICONS.ORLOGO size={100} />
      </div>

      <div
        className={styles.modalRight}
        style={{
          backgroundImage: `url(${settings?.data?.orderConfirmationPopupImage.url})`,
        }}
      ></div>
    </div>
  );
};

export default ContactCompleteModal;
